import closeMenu from './closeMenu'
/**
 * Opens the modal and traps focus.
 */
const openMenu = (
  focusedElementBeforeMenu: HTMLElement|null,
  mobileMenu: HTMLElement,
  menuOverlay: HTMLElement,
  menuToggle: HTMLElement
) => {

  if ( ! mobileMenu || ! menuOverlay ) return false

  const close = () => closeMenu( focusedElementBeforeMenu, mobileMenu, menuOverlay, menuToggle )

  const trapTabKey = ( e: KeyboardEvent ) => {
    console.log( 'trap', e )
		// Check for TAB key press
		if ( e.keyCode === 9 ) {

			// SHIFT + TAB
			if ( e.shiftKey ) {
				if ( document.activeElement === firstTabStop ) {
					e.preventDefault()
					lastTabStop.focus()
				}

				// TAB
			} else if ( document.activeElement === lastTabStop ) {
				e.preventDefault()
				firstTabStop.focus()
			}
		}

		// ESCAPE
		if ( e.keyCode === 27 ) close()
	}

	// Save current focus.
	focusedElementBeforeMenu = document.activeElement as HTMLElement

	// Listen for and trap the keyboard
	mobileMenu.addEventListener( 'keydown', trapTabKey )

	// Listen for indicators to close the modal.
	menuOverlay.addEventListener( 'click', () => close )

	// Modal close buttons.
	const closeButtons = mobileMenu.querySelectorAll( '[data-close-menu]' )

	// Attach listeners to all the close modal buttons.
  closeButtons.forEach( closeButton => closeButton.addEventListener( 'click', () => close() ) )

	// Find all focusable children.
	const focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]'
	let focusableElements = mobileMenu.querySelectorAll( focusableElementsString )

	// Convert NodeList to Array
	focusableElements = Array.prototype.slice.call( focusableElements )

	const firstTabStop = focusableElements[0] as HTMLElement
	const lastTabStop = focusableElements[focusableElements.length - 1] as HTMLElement

	// Show the modal and overlay
	// mobileMenu.style.display = 'block';
	// menuOverlay.style.display = 'block';
	menuToggle.setAttribute( 'aria-expanded', 'true' )
  console.log( 'mobileMenu', mobileMenu )
	mobileMenu.setAttribute( 'data-menu-closed', 'false' )
	mobileMenu.setAttribute( 'aria-hidden', 'false' )

	// This just allows for the animation, not required.
	setTimeout( () => mobileMenu.classList.remove( 'is-closed' ), 10 )

	// Focus first child
	firstTabStop.focus()

  return true

}

export default openMenu
